export const contexts = {
  login: 'login',
  authentication: 'authentication',
  masterServices: 'masterServices',
  services: 'services',
};

export const contextToPageNameMap = {
  login: 'Login',
  masterServices: 'Master Services',
  services: 'Services',
};

export const categories = {
  labs: 'labs',
  scans: 'scans',
  inclinic: 'inclinic',
  surgical: 'surgical',
};
